'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpMenu = void 0;
const $ = require("jquery");
class SpMenu {
    constructor() {
        this.OVER_PC_WIDTH = 1200;
        $(window).on('load resize', () => {
            const browserWidth = $(window).outerWidth();
            // 1200px未満
            if (browserWidth < this.OVER_PC_WIDTH) {
                const initIsOpen = $('.trigSwitchMenu').attr('data-is-open');
                if (initIsOpen === 'false') {
                    $('.bulletSwitchSearch').hide();
                }
            }
            else {
                $('.bulletSwitchMenu').hide();
                $('.bulletSwitchSearch').show();
                this.initSpMenu();
            }
        });
        $('.trigSwitchMenu').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                this.activeSpMenu();
                this.openFirstChildMenu();
            }
            else {
                this.initSpMenu();
            }
        });
    }
    // スマホメニュー オープンしたとき
    activeSpMenu() {
        $('.bulletSwitchSearch').show();
        $('.bulletSwitchMenu').fadeIn('slow');
        $('.trigSwitchMenu').attr('data-is-open', 'true');
        $('.bulletSwitchHeader').attr('data-is-open', 'true');
    }
    // スマホメニュー 初期表示
    initSpMenu() {
        $('.bulletSwitchSearch').hide();
        $('.bulletSwitchMenu').fadeOut('slow');
        $('.trigSwitchMenu').attr('data-is-open', 'false');
        $('.bulletSwitchHeader').attr('data-is-open', 'false');
        $('.trigFadeInSearchMenu').attr('data-is-open', 'false');
        $('.bulletFadeInSearchMenu').attr('data-is-open', 'false');
    }
    // 一つ目のコンテンツメニューを開く
    openFirstChildMenu() {
        //
        $('.trigShowChildMenu').attr('data-is-open', 'false');
        $('.bulletShowChildMenu').attr('data-is-open', 'false');
        $(`.trigShowChildMenu:first`).attr('data-is-open', 'true');
        $(`.bulletShowChildMenu:first`).attr('data-is-open', 'true');
    }
}
exports.SpMenu = SpMenu;
exports.default = SpMenu;
